import React from 'react';

const ModalContentSaveQuote = React.createClass({
    render() {
        return (
            <div>
                <p>Your quote has been saved. You should receive an email in your inbox shortly.</p>
            </div>
        );
    }
});

export default ModalContentSaveQuote;


/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentSaveQuote.js
 **/